export default {
  title: 'Aplikacje',
  fields: {
    id: 'ID',
    name: 'Nazwa',
    app_bundle_identifier: 'App Bundle ID',
    released: 'Wydana',
    franchise: 'Marka',
    app_icon: 'Ikona aplikacji',
    status: 'Status',
    play_store_link: 'Link do Play Store',
    apple_store_link: 'Link do Apple Store',
    dynamic_link: 'Dynamiczny link – kody QR',
  },
  filters: {
    name: 'Nazwa',
    released: 'Wydana',
  },
  columns: {
    backlog: '📋 Backlog',
    ready_to_build: '🛠️ Gotowe do budowania',
    in_work: '🔧 W realizacji',
    in_review: '📝 W recenzji',
    rejected: '❌ Odrzucona',
    released: '✅ Wydana',
    deactivated: '🛑 Dezaktywowana',
  },
  card: {
    overdue: 'Po terminie · {{time}}',
    copied: 'Skopiowano do schowka',
    released_tag: {
      both: '✅ Wydana',
      ios: 'iOS wydana',
      android: 'Android wydana',
    },
    tags: {
      has_tech_issue: 'Problem techniczny',
    },
  },
  status_modal: {
    title: 'Zaktualizuj status wydania',
    status_label: 'Status',
    note_label: 'Notatka (opcjonalna)',
    note_placeholder: 'Dodaj opcjonalną notatkę do tej zmiany statusu',
    tech_issue_checkbox: 'Wystąpił problem techniczny',
    save: 'Zapisz',
    cancel: 'Anuluj',
  },
  released: {
    yes: 'Tak',
    no: 'Nie',
  },
  configured_status: {
    true: 'Tak',
    false: 'Nie',
  },
  delete_confirmation: {
    title: 'Usuń aplikację mobilną',
    message: 'Czy na pewno chcesz usunąć tę aplikację mobilną?',
    buttons: {
      confirm: 'Potwierdź',
      cancel: 'Anuluj',
    },
  },
};
